module.exports = __webpack_public_path__ + "img/feature_buy_en.c80ccfb6.png";